import './libs/buffer';
import './libs/strings/index';

import {
  AccountPayable,
  AddNewCounterparty,
  AddNewPayee,
  BusinessDocumentActionMenu,
  DetailApPayeeDrawer,
  DetailApPayeeModal,
  DocInstructionMenu,
  FeatureFlagButton,
  FeatureFlagLayer,
  InvoiceActionMenu,
  InvoiceReportShareDrawer,
  IpAddressWhitelists,
  PdfViewer,
  ReportTypeEditTabs,
  TextLink,
  ViewerSelect,
} from './wc/components';
export { AccountPayablePage } from './wc/components';

const define = (name: string, comp: CustomElementConstructor) => {
  if (!window.customElements.get(name)) {
    customElements.define(name, comp);
  }
};

const entryPoint = () => {
  define('account-payable', AccountPayable);
  define('account-payable-invoice-action-menu', InvoiceActionMenu);
  define(
    'account-payable-business-document-action-menu',
    BusinessDocumentActionMenu
  );
  define('account-payable-add-new-counterparty', AddNewCounterparty);
  define('account-payable-text-link', TextLink);
  define('account-payable-feature-flag-button', FeatureFlagButton);
  define('account-payable-feature-flag-layer', FeatureFlagLayer);
  define('account-payable-add-new-payee', AddNewPayee);
  define('account-payable-detail-payee', DetailApPayeeModal);
  define('account-payable-pdf-viewer', PdfViewer);
  define('account-payable-doc-instruction-menu', DocInstructionMenu);
  define('account-payable-report-type-edit-tabs', ReportTypeEditTabs);
  define('account-payable-detail-payee-drawer', DetailApPayeeDrawer);
  define(
    'account-payable-invoice-report-share-drawer',
    InvoiceReportShareDrawer
  );
  define('account-payable-ip-address-whitelists', IpAddressWhitelists);
  define('account-payable-viewer-select', ViewerSelect);
};
if (
  (typeof process.env.MOCK === 'boolean' && process.env.MOCK) ||
  (String(process.env.MOCK) || '').toLowerCase() === 'true'
) {
  void (async () => {
    const [{ mockHandlers }, { mockAPI }] = await Promise.all([
      import('@/libs/mocks/handlers'),
      import('@/libs/mocks/hooks'),
    ]);
    await mockAPI(
      {
        serviceWorker: {
          url: `${import.meta.env.BASE_URL}apiMockServiceWorker.js`,
        },
      },
      ...mockHandlers
    );
    entryPoint();
  })();
} else {
  entryPoint();
}
